export const MAIN_COLOUR = "#022444";
export const TEAL_PRIMARY_COLOUR = "#55A6CA";
export const WHITE_COLOUR = "white";
export const SEARCH_BAR_DARK = "rgba(3,10,29, 0.88)";
export const DISABLED = "rgba(2, 36, 68, 0.45)";
export const GREY_NO_OPACITY = "#8d9cab";
export const TEAL_CONTAINER_COLOUR = "#EDF5FC";

export const NAVBAR_STYLES = {
  navbar: {
    backgroundColor: MAIN_COLOUR,
    height: "5em",
    borderBottom: "1px solid #F27D42",
    boxShadow: "rgba(0, 0, 0, 0.5) 0 4px 4px -1px",
  },
  navbarHome: {
    backgroundColor: MAIN_COLOUR,
    height: "5em",
    borderBottom: "1px solid #F27D42",
    boxShadow: "rgba(0, 0, 0, 0.5) 0 4px 4px -1px",
    transition: "all ease .20s",
  },
  navbarTransparent: {
    backgroundColor: "transparent",
    height: "5em",
  },
  browseJobs: {
    marginLeft: "24px",
    color: WHITE_COLOUR,
    fontSize: "17px",
  },
  buttonLink: {
    color: WHITE_COLOUR,
    fontSize: "17px",
  },
};

export const BUTTON_STYLES = {
  floatFilterButton: {
    backgroundColor: WHITE_COLOUR,
    padding: "8px 14px",
    margin: "0",
    color: MAIN_COLOUR,
    fontFamily: "Lato, sans-serif",
    border: "1px solid rgba(2, 36, 68, 0.3)",
    borderRadius: 13,
    fontSize: 15,
    zIndex: 15,
  },
};

export const SEMANTIC_DIV = {
  padding: 0,
  margin: 0,
};

export const TEAL_BOX = {
  padding: "18px 22px",
  backgroundColor: WHITE_COLOUR,
  borderRadius: 10,
  border: "1px solid #BCE0FD",
};

export const HALF_STAT = {
  width: "50%",
  padding: "18px 22px",
  margin: 0,
  backgroundColor: WHITE_COLOUR,
  borderRadius: "10px 0 0 10px",
  border: "1px solid #BCE0FD",
};

export const HALF_STAT_TEXT = {
  width: "50%",
  textAlign: "left",
  padding: "18px 22px",
  borderRadius: "0 10px 10px 0",
  backgroundColor: "rgba(188, 224, 253, 0.14)",
  fontSize: 15,
};
